import Qs from 'qs';
import axios from '@/mod/axiosMod';

export default {
  /**
   * 查询昨日问题门店数量
   * @param {*} data
   * @returns
   */
  getPoiCnt(params) {
    return axios.get('/apigw/api/kdb/service-level/poi-cnt', { params });
  },
  /**
   * 查询门店列表
   * @param {*} data
   * @returns
   */
  getPoiList(params) {
    return axios.get('/apigw/api/kdb/service-level/poi-list', { params, paramsSerializer: () => Qs.stringify(params, { indices: false }) });
  },
  /**
   * 查询门店服务待优化项数量
   * @param {*} data
   * @returns
   */
  getPoiOptimizeCnt(params) {
    return axios.get('/apigw/api/kdb/service-level/poi-optimize-cnt', { params });
  },
  /**
   * 查询门店服务等级
   * @param {*} data
   * @returns
   */
  getPoiServiceLevel(params) {
    return axios.get('/apigw/api/kdb/service-level/poi-grade', { params });
  },
  /**
   * 查询门店服务待优化项详情
   * @param {*} data
   * @returns
   */
  getPoiOptimizeDetail(params) {
    return axios.get('/apigw/api/kdb/service-level/poi-optimize-detail', { params });
  },
  /**
   * 查询门店服务待优化项的具体天数
   * @param {*} data
   * @returns
   */
  getPoiOptimizeDt(params) {
    return axios.get('/apigw/api/kdb/service-level/poi-optimize-dt', { params });
  },
};
// /api/cdb/poi/v4
